import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { merge } from 'lodash';

import language from '@/util/language';
import SMP_CONFIG from '@/util/smp_config';
import helper from '@/util/helpers';

import bg from './bg/translations.json';
import cs from './cs/translations.json';
import de from './de/translations.json';
import el from './el/translations.json';
import en from './en/translations.json';
import es from './es/translations.json';
import hu from './hu/translations.json';
import it from './it/translations.json';
import nl from './nl/translations.json';
import pt from './pt/translations.json';
import ru from './ru/translations.json';
import tr from './tr/translations.json';

Vue.use(VueI18n);

export function createI18n () {
  const showTags = helper.getUrlQueryParameter('show_tagname');
  let extended = SMP_CONFIG.contextConfig.extended;
  let contextTranslations = (extended && extended.translations && JSON.parse(extended.translations)) || {};

  let messages = {
    'bg': bg,
    'cs': cs,
    'el': el,
    'en': en,
    'es': es,
    'de': de,
    'hu': hu,
    'it': it,
    'nl': nl,
    'pt': pt,
    'ru': ru,
    'tr': tr
  };

  if (showTags.length && showTags[0]) {
    messages[language.getCurrentLanguage()] = {};
  } else {
    merge(messages, contextTranslations);
  }

  return new VueI18n({
    locale: language.getCurrentLanguage(),
    messages: messages,
    silentTranslationWarn: true
  })
}
